export const getBaseurl = () => {
  return `${window.location.protocol}//${window.location.host}`;
};
